export default __webpack_public_path__ + "static/media/questionnaire_management_icon.390051e6.svg";